import { useState } from "react";
import { STEPS } from "@/lib/shipments";
import { chip } from "@/components/site/OrderSpecFields";
import { pInput } from "@/components/admin/proposal/ItemRows";

// Nova etapa da entrega: escolha a etapa + cidade, local e observação.
export const EventForm = ({ id, current, busy, onAdd }) => {
  const next = STEPS[Math.min(STEPS.findIndex((s) => s.id === current) + 1, STEPS.length - 1)]?.id || "preparando";
  const [f, setF] = useState({ step: next, city: "", place: "", note: "" });
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (await onAdd(f)) setF((s) => ({ ...s, step: STEPS[Math.min(STEPS.findIndex((x) => x.id === s.step) + 1, STEPS.length - 1)].id, place: "", note: "" }));
  };
  return (
    <form data-testid={`shipment-event-form-${id}`} onSubmit={submit} className="rounded-2xl border border-white/10 p-3">
      <p className="text-sm font-semibold text-white">Atualizar entrega</p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {STEPS.map((s) => <button type="button" key={s.id} data-testid={`shipment-event-step-${id}-${s.id}`} onClick={() => setF((x) => ({ ...x, step: s.id }))} className={chip(f.step === s.id)}>{s.label}</button>)}
      </div>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        <input data-testid={`shipment-event-city-${id}`} value={f.city} maxLength={80} onChange={set("city")} placeholder="Cidade (ex: Pouso Alegre-MG)" className={pInput} />
        <input data-testid={`shipment-event-place-${id}`} value={f.place} maxLength={120} onChange={set("place")} placeholder="Local (ex: Centro de distribuição)" className={pInput} />
        <input data-testid={`shipment-event-note-${id}`} value={f.note} maxLength={300} onChange={set("note")} placeholder="Observação (opcional)" className={`${pInput} sm:col-span-2`} />
      </div>
      <button type="submit" data-testid={`shipment-event-add-${id}`} disabled={busy} className="mt-3 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-black transition-transform hover:scale-[1.02] disabled:opacity-40">{busy ? "Salvando…" : "Salvar etapa"}</button>
    </form>
  );
};
